/**
 * Created by elad on 20 נובמבר 2016.
 */
import UserService from "src/packages/AuthService";
import { types as RolesTypes } from "dev/config/roles";

export const types = {
	LOGIN: "auth/login",
	GET: "auth/get",
	PASSWORD: "auth/password",
	LOGOUT: "auth/logout",
	SAVE: "auth/save",
	STORE: "auth/store",
	UPDATE: "auth/update",
	LOGOUT_PASSPORT: "auth/logoutPassport"

};
export default {

	state: {
		user: {},

	},
	getters: {
		authCompany (state) {
			return state.user?.company;
		},
		isConnected (state) {
			return !!state.user.id;
		},
		isTeamHead (state) {
			return +state.user.role === RolesTypes.TEAM_HEAD;
		},
		isCompany (state) {
			return !!state.user?.is_multi_user_company;
		},
		companyName (state) {
			return state.user?.company?.name;
		},
		isManager (state) {
			return +state.user.role <= RolesTypes.MANAGER;
		},
		isAdmin (state) {
			return +state.user.role === RolesTypes.ADMIN;
		},
		subscription (state) {
			return state.user.company?.current_payment_tokens?.decode;
		},
		gamesInPlan (state) {
			let games = state.user?.company?.additional_games || 0;
			games += state.user?.company?.current_payment_tokens?.meta.num_games || 0;
			return games;
		},
		canCreateGame(state,getters){
			return +getters.gamesInPlan > +getters.gamesCount;
		},
		selectedLanguage(){
			return document.documentElement.lang;
		},
		isPro(state){
			return state.user?.company?.subscription_type === "premium";
		}

	},
	mutations: {
		[types.LOGIN] (state, userLogin) {
			state.user = userLogin;
		},
		[types.LOGOUT] (state) {
			state.user = {};
		},

	},

	actions: {
		[types.LOGIN] (context, form) {
			return UserService.login(form).then((response) => {
				context.commit(types.LOGIN, response);
				return response;
			});
		},
		[types.GET] (context) {
			return UserService.getAuth().then((response) => {
				context.commit(types.LOGIN, response);
				return response.data;
			});
		},
		[types.SAVE] (context, user) {
			if (user.id) {
				return context.dispatch(types.UPDATE, user);
			} else {
				return context.dispatch(types.STORE, user);
			}
		},
		[types.STORE] (context, data) {
			return UserService.create(data).then((response) => {
				if (response.id) {
					context.commit(types.LOGIN, response);
				}
				return response;
			});
		},
		[types.UPDATE] (context, data) {
			return UserService.update(data.id, data).then((response) => {
				context.commit(types.LOGIN, response);
				return response;
			});
		},
		[types.PASSWORD] (state, form) {
			return UserService.sendPassword(form).then((response) => {
				return response.data;
			});
		},
		[types.LOGOUT] (context) {
			return UserService.logout()
				.then(
					response => {
						if (response.success) {
							context.commit(types.LOGOUT);
						}
						return response;
					}
				);
		},
		[types.LOGOUT_PASSPORT]() {
			return UserService.logoutPassport()
		}

	},
	types: types,
};
